import React, { useEffect, useState } from "react";
import styles from './LogReportStudents.module.scss';
import PageTitle from "../../../components/pageTitle/PageTitle";
import Filter from "../../../components/filter/Filter";
import Button from "../../../components/button/Button";
import { useNavigate } from "react-router-dom";
import LoadingOverlay from "../../../components/loadingOverlay/LoadingOverlay";
import axiosClient from "../../../api/axiosClient";
import { useToasts } from "../../../contexts/ToastContext";
import StudentAllocationCard from "../../../components/studentAllocationCard/StudentAllocationCard";
import LoadMore from "../../../components/loadMore/loadMore";

const LogReportStudents = () => {
  const limit = 20;
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadMoreLoading, setIsLoadMoreLoading] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState('');
  const [students, setStudents] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();
  const { showToast } = useToasts();

  useEffect(() => {
    const fetchData = async () => {
      if(page === 1) {
        setIsLoading(true);
      } else {
        setIsLoadMoreLoading(true);
      }
      const params = {
        limit: limit,
        page: page,
      };
      if(selectedFilter) {
        params.filter = selectedFilter;
      }
      await axiosClient.get(`log-reports/students`, {
        params: params
      })
      .then ((response) => {
        if(response.data?.students) {
          if(page === 1) {
            setStudents([]);
          }
          setStudents((prevData) => {
            return [...prevData, ...response.data.students.map((student) => ({
              id: student.id,
              profilePicture: student?.profilePicture ?? null,
              firstName: student?.firstName ?? '',
              lastName: student?.lastName ?? '',
              data: [
                {
                  label: 'Year',
                  value: student?.year?.year ?? ''
                },
                {
                  label: 'Semester',
                  value: student?.semester?.semester ?? ''
                },
                {
                  label: 'Month',
                  value: student?.month?.month ?? ''
                },
              ],
            }))];
          });
          setTotalPages(response.data.totalPages);
        }
      })
      .catch((error) => {
        showToast(error.message, 'error');
      })
      .finally(() => {
        setIsLoading(false);
        setIsLoadMoreLoading(false);
      });
    };

    fetchData();
  }, [page, selectedFilter, showToast]);

  const loadMore = async () => {
    setPage(page + 1);
  };

  return (
    <>
      {isLoading && <LoadingOverlay />}
      <div className={styles.header}>
        <PageTitle
          label="Log Reports"
        />
      </div>
      <div className={styles.container}>
        <div className={styles.topBar}>
          <div className={styles.filter}>
            <Filter
              filters={[
                {
                  label: 'All',
                  value: '',
                },
                {
                  label: 'First Year',
                  value: 'FirstYear',
                },
                {
                  label: 'Second Year',
                  value: 'SecondYear',
                },
                {
                  label: 'Third Year',
                  value: 'ThirdYear',
                }
              ]}
              selected={selectedFilter}
              onChange={(filter) => {
                setSelectedFilter(filter);
              }}
            />
          </div>
          <Button
            label="Bulk&nbsp;Export"
            size="medium"
            onClick={() => navigate(`/log-reports/export`)}
          />
        </div>
        { students.length > 0 ? <div className={styles.cardList}>
          {students.map((student, index) => {
            return (
              <div className={styles.cardItem} key={`student-${index}`}>
                <StudentAllocationCard
                  {...student}
                  onClick={() => navigate(`/log-reports/student/${student.id}`)}
                />
              </div>
            );
          })}
          {(isLoadMoreLoading || page < totalPages) 
            && <LoadMore isLoading={isLoadMoreLoading} onClick={loadMore} />}
        </div> : !isLoading && <div className={styles.emptyStudents}>
          <p>You have no students at this time.</p>
        </div>}
      </div>
    </>
  );
};

export default LogReportStudents;